import React, {useEffect, useState} from "react";
import { Button, Container, Grid, TextField } from "@mui/material";



export const NewStationForm = ({submit, ...props}) => {
  const [station, setStation] = useState({Name: "", latitude: "", longitude: "", pauAssignments: []});

  const setProperty = (target, value) => {
    setStation({...station, [target]: value});
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <TextField 
          variant="outlined"
          label="Name"
          value={station.name}
          onChange={(e) => setProperty("name", e.target.value)}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          variant="outlined"
          label="Longitude"
          value={station.longitude}
          onChange={(e) => setProperty("longitude", e.target.value)}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          variant="outlined"
          label="Latitude"
          value={station.latitude}
          onChange={(e) => setProperty("latitude", e.target.value)}
        />
      </Grid>
      <Grid item xs={4}>
        <Button variant="contained" onClick={() => submit(station)} fullWidth>
          Submit
        </Button>
      </Grid>
    </Grid>
  )
}